import { apiGet, apiPut, apiPatch, apiPost } from "./client";
import type { Narrative, NarrativeCaseStudy } from "@sales-ops-amplify/shared";

export type NarrativePatch = {
  content?: string;
  products?: string[];
  caseStudies?: NarrativeCaseStudy[];
  icpSummary?: string;
  proofPoints?: string[];
};

export async function getNarrative(): Promise<Narrative> {
  return apiGet<Narrative>("/api/narrative");
}

export async function updateNarrative(
  contentOrPatch: string | NarrativePatch,
): Promise<Narrative> {
  const body: NarrativePatch =
    typeof contentOrPatch === "string"
      ? { content: contentOrPatch }
      : contentOrPatch;
  return apiPut<Narrative>("/api/narrative", body);
}

export async function patchNarrative(patch: NarrativePatch): Promise<Narrative> {
  return apiPatch<Narrative>("/api/narrative", patch);
}

export async function ingestNarrative(
  text: string,
  options?: { useAi?: boolean },
): Promise<Narrative> {
  return apiPost<Narrative>("/api/narrative/ingest", {
    content: text,
    useAi: options?.useAi ?? true,
  });
}

export type { Narrative, NarrativeCaseStudy };
